// Central SEO configuration + JSON-LD builders for АРГАЛИ

export const SITE = {
  name: "АРГАЛИ",
  alternateNames: ["ARGALI", "ARGALI Altai", "АРГАЛИ Алтай"],
  origin: "https://argali-altai.com",
  defaultTitle: "АРГАЛИ — экскурсии по Горному Алтаю",
  defaultDescription:
    "АРГАЛИ — индивидуальные экскурсии и этнотуризм в Республике Алтай с аттестованным гидом. Дикая природа, горы, культура и маршруты в малых группах.",
  defaultDescriptionEn:
    "АРГАЛИ (ARGALI) offers private excursions and ethno-tourism in the Altai Republic with an attested local guide, small groups, wildlife and mountain routes.",
  defaultImage: "/brand/argali_social_ru.jpg",
  phone: "+79941102511",
  email: "argalialtai@yandex.ru",
  region: "Республика Алтай, Россия",
  sameAs: [
    "https://www.instagram.com/argalialtai",
    "https://t.me/argali_altai",
    "https://www.youtube.com/@ArgaliAltai",
    "https://yandex.ru/maps/org/argali/149759078052/",
  ],
};

const abs = (p) => (p ? (p.startsWith("http") ? p : SITE.origin + p) : undefined);

export const localBusinessLd = (lang) => ({
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "@id": `${SITE.origin}/#business`,
  name: SITE.name,
  alternateName: SITE.alternateNames,
  legalName: "ИП Кушерова Арина Нурлановна",
  description: lang === "en" ? SITE.defaultDescriptionEn : SITE.defaultDescription,
  url: SITE.origin,
  image: abs("/photos/photo_confluence.jpg"),
  logo: {
    "@type": "ImageObject",
    url: abs("/brand/argali_favicon_ru_v2.png"),
    width: 512,
    height: 512,
  },
  brand: {
    "@type": "Brand",
    name: SITE.name,
    alternateName: "ARGALI",
    logo: abs("/brand/argali_favicon_ru_v2.png"),
  },
  telephone: SITE.phone,
  email: SITE.email,
  sameAs: SITE.sameAs,
  identifier: {
    "@type": "PropertyValue",
    propertyID: "ОГРНИП",
    value: "326040000003380",
  },
  priceRange: "$$",
  areaServed: { "@type": "AdministrativeArea", name: "Altai Republic, Russia" },
  address: { "@type": "PostalAddress", addressRegion: "Altai Republic", addressCountry: "RU" },
  slogan: lang === "en" ? "Ethno-tourism · Wildlife · Mountains" : "Этнотуризм · Дикая природа · Горы",
});

export const personLd = (guide, lang) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": `${SITE.origin}/guide#guide`,
  name: lang === "en" ? guide?.name_en : guide?.name_ru,
  jobTitle: lang === "en" ? "Attested excursion guide, Altai Republic" : "Аттестованный экскурсовод Республики Алтай",
  identifier: guide?.guide_number,
  worksFor: { "@id": `${SITE.origin}/#business` },
  knowsLanguage: ["ru", "en"],
});

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: abs(it.path),
  })),
});

export const excursionLd = (exc, lang, image) => ({
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "@id": `${SITE.origin}/excursions/${exc.slug}#trip`,
  name: lang === "en" ? exc.title_en : exc.title_ru,
  description: lang === "en" ? exc.short_description_en : exc.short_description_ru,
  image: abs(image),
  url: `${SITE.origin}/excursions/${exc.slug}`,
  touristType: lang === "en" ? "Private, small group" : "Индивидуально, малые группы",
  provider: { "@id": `${SITE.origin}/#business` },
  itinerary: {
    "@type": "ItemList",
    itemListElement: (exc.place_ids || []).map((pid, i) => ({ "@type": "ListItem", position: i + 1, name: pid })),
  },
});

export const attractionLd = (place, lang, image) => ({
  "@context": "https://schema.org",
  "@type": "TouristAttraction",
  name: lang === "en" ? place.name_en : place.name_ru,
  image: abs(image),
  address: { "@type": "PostalAddress", addressRegion: place.district, addressCountry: "RU" },
  geo: { "@type": "GeoCoordinates", latitude: place.lat, longitude: place.lng },
});

export const faqLd = (faqs, lang) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => {
    const pair = lang === "en" ? f.en : f.ru;
    return {
      "@type": "Question",
      name: pair[0],
      acceptedAnswer: { "@type": "Answer", text: pair[1] },
    };
  }),
});
